export enum FunnelStateKey {
  AnyNursingApprenticeshipExperience = 'any-nursing-apprenticeship-experience',
  AnyQualifications = 'any-qualifications',
  AnyJobYearsOfExperience = 'any-job-years-of-experience',
  CvFiles = 'files',
  Departments = 'departments',
  DocumentationSystems = 'documentation-systems',
  DriversLicense = 'drivers-license',
  GermanSpeakingLevel = 'german-speaking-level',
  HowHappyAreYou = 'how-happy-are-you',
  JobQualification = 'job-qualification',
  JobYearsOfExperience = 'job-years-of-experience',
  LgTraining = 'lg-training',
  Locations = 'locations',
  MaxDistance = 'max-distance',
  NursingApprenticeshipExperience = 'nursing-apprenticeship-experience',
  PermanentOrTemporary = 'permanent-or-temporary',
  PhoneNumber = 'phone-number',
  Qualifications = 'qualifications',
  SalaryExpectation = 'salary-expectation',
  ShiftSystem = 'shift-system',
  TransportationType = 'transportation-type',
  TypesOfWork = 'types-of-work',
  WantFromEmployers = 'want-from-employers',
  Wishlist = 'wishlist',
  YearsOfExperience = 'years-of-experience',
}
